import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { CoreService } from './core.service';
import { CoreComponent } from './core.component';
import { HeaderComponent } from './header.component';
import { FooterComponent } from './footer.component';
import { Main } from './main.service';
import { AuthModule } from '../auth/auth.module';

import { RouteReusableStrategy } from './route-reusable-strategy';
import { LoaderComponent } from './loader.component';
import { LaddaModule } from 'angular2-ladda';
/* import { ToastyModule } from 'ng2-toasty'; */

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    /* ToastyModule.forRoot(), */
    LaddaModule,
    AuthModule,
  ],
  declarations: [CoreComponent, LoaderComponent, HeaderComponent, FooterComponent],
  exports: [
    LoaderComponent, NgxPaginationModule
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy,
    },
    CoreService,
    Main,
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded.`);
    }
  }
}
